import { Col, Form, Row } from "react-bootstrap"
import { NumericFormat } from "react-number-format"
import { useDispatch, useSelector } from "react-redux"

const InsuredTotalAnnual = ({ applicationData, updateApplication, validationError }) => {
    const currentYear = new Date().getFullYear()
    const previousYear = currentYear - 1

    return (
        <div className="mt-4">
            <h6>2. Please provide the Insured’s total annual contracting revenues for the following:</h6>
            <Row className="mb-2">
                <Col
                    md="2"
                    className="d-flex align-items-center">
                    <NumericFormat
                        className={`form-control form-control-sm ${
                            validationError?.contractingRevenuesPriorCalendarYear ? "error" : ""
                        }`}
                        name="contractingRevenuesPriorCalendarYear"
                        value={applicationData?.contractingRevenuesPriorCalendarYear || ""}
                        onChange={(e) =>
                            updateApplication({
                                currentTarget: {
                                    value: parseFloat(e.target.value?.replace("$", "").replaceAll(",", "")),
                                    name: "contractingRevenuesPriorCalendarYear"
                                }
                            })
                        }
                        fixedDecimalScale={0}
                        decimalScale={0}
                        allowNegative={false}
                        prefix={"$"}
                        thousandSeparator
                        placeholder={"$0"}
                    />
                </Col>
                <Col className="d-flex align-items-center">
                    <Form.Label>For the prior calendar year. ({previousYear})</Form.Label>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col
                    md="2"
                    className="d-flex align-items-center">
                    <NumericFormat
                        className={`form-control form-control-sm ${
                            validationError?.contractingRevenuesCurrentCalendarYear ? "error" : ""
                        }`}
                        name="contractingRevenuesCurrentCalendarYear"
                        value={applicationData?.contractingRevenuesCurrentCalendarYear || ""}
                        onChange={(e) =>
                            updateApplication({
                                currentTarget: {
                                    value: parseFloat(e.target.value?.replace("$", "").replaceAll(",", "")),
                                    name: "contractingRevenuesCurrentCalendarYear"
                                }
                            })
                        }
                        fixedDecimalScale={0}
                        decimalScale={0}
                        allowNegative={false}
                        prefix={"$"}
                        thousandSeparator
                        placeholder={"$0"}
                    />
                </Col>
                <Col className="d-flex align-items-center">
                    <Form.Label>Estimated for the current calendar year. ({currentYear})</Form.Label>
                </Col>
            </Row>
        </div>
    )
}

export default InsuredTotalAnnual
